import { collection, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { db } from "../../firebase/config";

async function getUserDocByUid(uid) {
  const snap = await getDocs(
    query(collection(db, "users"), where("uid", "==", uid))
  );
  if (snap.empty) return null;
  return { id: snap.docs[0].id, data: snap.docs[0].data() };
}

/** ₹150 per COP block — Cash Out box balance (separate from Auto Fill CO Points). */
export async function creditCashOutBox(userId, amount, meta = {}) {
  const amt = Number(amount);
  if (!userId || amt <= 0) return { credited: false };

  const userDoc = await getUserDocByUid(userId);
  if (!userDoc) return { credited: false, reason: "user_not_found" };

  const box = userDoc.data.cashOutBox || {
    earned: 0,
    available: 0,
    withdrawn: 0,
  };

  await updateDoc(doc(db, "users", userDoc.id), {
    cashOutBox: {
      earned: (box.earned || 0) + amt,
      available: (box.available || 0) + amt,
      withdrawn: box.withdrawn || 0,
    },
    updatedAt: new Date().toISOString(),
  });

  return {
    credited: true,
    amount: amt,
    sourceProgramId: meta.sourceProgramId || null,
    cartOrderId: meta.cartOrderId || null,
  };
}
